import React from 'react';
import Panel from './Panel';
import List from '../../components/Panel/Inclusao/List';




const ListInclusion = () => {

    return (
        <Panel>
            <div>
                <List />
            </div>
        </Panel>

    );
};

export default ListInclusion;



/** WEBPACK FOOTER **
 ** ./src/containers/Panel/ListInclusion.js
 **/